
<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}"
  >
    <div class="md-toolbar-row">
      <!-- <div class="md-toolbar-section-start">
        <h3 class="md-title">{{$route.name}}</h3>
      </div>-->
      <div class="md-toolbar-section-start">
        <md-button class="md-just-icon md-round goBack" @click="back">
          <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
        <!-- <div class="md-autocomplete">
          <md-autocomplete
            class="search"
            v-model="selectedEmployee"
            :md-options="employees"
            :md-open-on-focus="false"
          >
            <label>Search...</label>
          </md-autocomplete>
        </div>-->
        <!-- <md-list>
            <md-list-item to="/">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

            <li class="md-list-item">
              <a href="#/components/notifications" class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button slot="title" class="md-button md-just-icon md-simple" data-toggle="dropdown">
                      <md-icon>notifications</md-icon>
                      <span class="notification">5</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li><a href="#">Mike John responded to your email</a></li>
                      <li><a href="#">You have 5 new tasks</a></li>
                      <li><a href="#">You're now friend with Andrew</a></li>
                      <li><a href="#">Another Notification</a></li>
                      <li><a href="#">Another One</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item to="/pages/user">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
        </md-list>-->
      </div>

      <div class="md-toolbar-section-end">
        <!-- <md-button class="md-just-icon md-round md-simple md-toolbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
        <md-button class="md-fab md-primary md-round md-just-icon">
        <md-icon>add</md-icon>
        </md-button>-->
        <!-- <div class="navActions"> -->
        <!-- <span v-if="isNotify"> -->
        <md-button v-if="user.notify" class="md-round md-info" @click="notify">
          <span>Notificar?</span>
        </md-button>
        <md-button v-else class="md-round md-danger" @click="notify">
          <span>Notificar?</span>
        </md-button>
        <!-- </span> -->
        <md-button class="md-just-icon md-round md-danger" @click="logout">
          <md-icon>exit_to_app</md-icon>
        </md-button>
        <!-- </div> -->
        <Ftb v-if="showAdd"></Ftb>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import Ftb from "../Components/Ftb";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Ftb
  },
  data() {
    return {
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone"
      ]
    };
  },
  computed: {
    ...mapGetters({
      isDetail: "isDetail",
      showAdd: "showAdd",
      showBottom: "showBottom",
      user: "users/user"
    }),
    isNotify() {
      console.warn();

      if (this.$route.path.toString() === "/microservices") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions({
      closeSession: "users/logout",
      update: "users/update"
    }),
    notify() {
      console.warn("notify");
      console.warn(this.user);

      console.warn("notify");
      this.update({ notify: !this.user.notify });
    },
    logout() {
      this.closeSession().then(res => {
        this.$router.push("/login");
      });
    },
    back() {
      this.$router.go(-1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>
<style scoped>
.goBack {
  margin-right: 15px;
}
.md-toolbar-section-end {
  margin-right: 50px;
}
/* .md-toolbar {
  position: fixed;
  z-index: 100;
} */
</style>

